import React from 'react';

class MotionSensorIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_241_704)">
          <g filter="url(#filter0_d_241_704)">
            <path
              d="M24.2944 4H55.7744C56.5904 4 57.2524 4.662 57.2524 5.478V41.652C57.2524 42.468 56.5904 43.13 55.7744 43.13H24.2944C23.4784 43.13 22.8164 42.468 22.8164 41.652V5.478C22.8164 4.662 23.4784 4 24.2944 4Z"
              fill="#F7F4F1"
            />
            <path
              d="M54.1203 11.0439H25.9463V36.0879H54.1203V11.0439Z"
              fill="url(#paint0_linear_241_704)"
            />
            <path
              d="M51.606 71.304C49.326 70.15 47.684 68.026 47.408 65.478L46.66 58.54C46.58 57.79 45.906 57.218 45.102 57.218H34.964C34.16 57.218 33.488 57.79 33.406 58.54L32.658 65.478C32.384 68.026 30.74 70.15 28.46 71.304H51.604H51.606Z"
              fill="#F7F4F1"
            />
            <path
              d="M55.2157 71.304H24.8497C24.1582 71.304 23.5977 71.8645 23.5977 72.556V74.748C23.5977 75.4394 24.1582 76 24.8497 76H55.2157C55.9071 76 56.4677 75.4394 56.4677 74.748V72.556C56.4677 71.8645 55.9071 71.304 55.2157 71.304Z"
              fill="#F7F4F1"
            />
            <path
              d="M55.7716 3.19995H24.2936C23.0376 3.19995 22.0156 4.22195 22.0156 5.47795V41.652C22.0156 42.908 23.0376 43.93 24.2936 43.93H36.8856V56.4179H34.9656C33.7496 56.4179 32.7376 57.2939 32.6136 58.4539L31.8656 65.3919C31.6356 67.518 30.2916 69.4139 28.2596 70.504H24.8516C23.7196 70.504 22.7996 71.424 22.7996 72.556V74.7479C22.7996 75.88 23.7196 76.7999 24.8516 76.7999H55.2176C56.3496 76.7999 57.2696 75.88 57.2696 74.7479V72.556C57.2696 71.424 56.3496 70.504 55.2176 70.504H51.8096C49.7776 69.4139 48.4336 67.518 48.2036 65.3919L47.4556 58.4539C47.3316 57.2939 46.3196 56.4179 45.1036 56.4179H43.1836V43.93H55.7756C57.0316 43.93 58.0536 42.908 58.0536 41.652V5.47795C58.0536 4.22195 57.0316 3.19995 55.7756 3.19995H55.7716ZM55.6676 72.556V74.7479C55.6676 74.9979 55.4656 75.2 55.2156 75.2H24.8496C24.5996 75.2 24.3976 74.9979 24.3976 74.7479V72.556C24.3976 72.306 24.5996 72.104 24.8496 72.104H55.2156C55.4656 72.104 55.6676 72.306 55.6676 72.556ZM24.2936 4.79995H55.7736C56.1476 4.79995 56.4516 5.10395 56.4516 5.47795V10.244H23.6156V5.47795C23.6156 5.10395 23.9196 4.79995 24.2936 4.79995ZM56.4516 35.2859H23.6156V11.844H56.4496V35.288L56.4516 35.2859ZM45.8656 58.624L46.6136 65.562C46.8156 67.4419 47.7056 69.176 49.0956 70.502H30.9716C32.3616 69.174 33.2516 67.4419 33.4536 65.562L34.2016 58.624C34.2376 58.284 34.5736 58.0159 34.9636 58.0159H45.1016C45.4916 58.0159 45.8276 58.282 45.8636 58.624H45.8656ZM55.7736 42.33H24.2936C23.9196 42.33 23.6156 42.026 23.6156 41.652V36.886H56.4496V41.652C56.4496 42.026 56.1456 42.33 55.7716 42.33H55.7736Z"
              fill="#83827F"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_241_704"
            x="20.6156"
            y="1.79995"
            width="42.0381"
            height="79.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_704"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_704"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_704"
            x1="29.909"
            y1="13.2839"
            x2="46.5262"
            y2="34.7271"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_241_704">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default MotionSensorIcon;
